import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Paper, List, ListItem, ListItemText, IconButton } from '@material-ui/core'
import { MoreVert } from '@material-ui/icons'

import { useSelectors } from '../../../../store'
import { styles } from './styles'

// Once per module: makeStyles called inside a render built a new JSS sheet,
// with new class names, on every render (booking screen, 11 Oct 2026).
const useStyles = makeStyles(styles)

export const UserCredit = React.memo(() => {
  const classes = useStyles()
  const { userCredit, userCreditCents } = useSelectors()

  return (
    userCreditCents > 0 && (
      <Paper className={classes.container}>
        <List className={classes.list}>
          <ListItem className={classes.item}>
            <ListItemText className={classes.itemText} primary={`Credit ${userCredit}`} />
            <IconButton edge="end" size="small">
              <MoreVert />
            </IconButton>
          </ListItem>
        </List>
      </Paper>
    )
  )
})
